import React, { useState, useEffect, useRef } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/style.css';
import axios from 'axios';
import swal from 'sweetalert';
import { NavLink, useNavigate } from "react-router-dom";
import "./AddDoctor.css";
import { removeToken } from '../Login/Authutils';
import AdminSidebar from '../Adminsidebar/AdminSidebar';

const ManageDoctorProfiles = () => {
    const navigate = useNavigate();
    const handleLogout = async () => {
        try {
            await axios.post(`${baseUrl}/logout`, {}, { withCredentials: true });
            removeToken();
            navigate('/login');
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };
    const [activeLink, setActiveLink] = useState(null);
    const handleLinkClick = (link) => {
        setActiveLink(link);
    };

    const [doctors, setDoctors] = useState([]); // This holds the list of DOCTOR PROFILES from /about
    
    // <<< NEW STATE: To hold the list of all registered doctors for the dropdown >>>
    const [allRegisteredDoctors, setAllRegisteredDoctors] = useState([]);

    const [formData, setFormData] = useState({
        doctorId: "",
        description: "",
        education: [],
        workExperience: [],
        awards: [],
        services: [],
        specialization: [],
    });
    const [showEditForm, setShowEditForm] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [editDoctorId, setEditDoctorId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.hitkarihospital.com:5005';
    const baseUrl = process.env.API_BASE_URL ||'https://api.hitkarihospital.com:5005';
    const dataTableInitialized = useRef(false);

    useEffect(() => {
        // This function fetches existing DOCTOR PROFILES from the '/about' endpoint
        fetchDoctors();

        // <<< NEW: This function fetches ALL doctors to populate the dropdown >>>
        const fetchAllDoctorsForDropdown = async () => {
            try {
                // IMPORTANT: Assumes an endpoint '/doctors' exists that returns all doctors
                // with at least 'doctorId' and 'name' fields.
                // e.g., [{ doctorId: "D001", name: "Dr. John Smith" }, ...]
                const response = await axios.get(`${API_BASE_URL}/api/doctor`);
                setAllRegisteredDoctors(response.data);
            } catch (err) {
                console.error("Error fetching all doctors for dropdown:", err);
                swal({
                    title: "Data Loading Warning",
                    text: 'Could not load the list of all doctors. The dropdown for adding new profiles may not work.',
                    icon: "warning",
                });
            }
        };

        fetchAllDoctorsForDropdown();
    }, []);

    useEffect(() => {
        if (doctors.length > 0 && window.$ && window.$.fn.DataTable) {
            const tableSelector = '.adddoctor-datatable';
            if (!dataTableInitialized.current) {
                dataTableInitialized.current = true;
                setTimeout(() => {
                    if (window.$(tableSelector).length) {
                        window.$(tableSelector).DataTable({
                            "paging": true, "ordering": true, "info": true, "scrollX": false, destroy: true, responsive: true
                        });
                    }
                }, 200);
            } else {
                if (window.$(tableSelector).length && window.$.fn.dataTable.isDataTable(tableSelector)) {
                    window.$(tableSelector).DataTable().destroy();
                }
                setTimeout(() => {
                    if (window.$(tableSelector).length) {
                        window.$(tableSelector).DataTable({
                            "paging": true, "ordering": true, "info": true, "scrollX": false, destroy: true, responsive: true
                        });
                    }
                }, 200);
            }
        }
        return () => {
            const tableSelector = '.adddoctor-datatable';
            if (window.$ && window.$.fn.DataTable && window.$.fn.dataTable.isDataTable(tableSelector)) {
                window.$(tableSelector).DataTable().destroy();
                dataTableInitialized.current = false;
            }
        };
    }, [doctors]);

    const fetchDoctors = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/about`);
            setDoctors(response.data);
        } catch (err) {
            setError(err);
            swal({
                title: "Error!", text: 'Error fetching doctors: ' + err.message, icon: "error", button: "OK",
            });
            console.error("Error fetching doctors:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleArrayChange = (e, field, index, subField) => {
        const newArray = [...formData[field]];
        if (!newArray[index]) {
            newArray[index] = {};
        }
        newArray[index][subField] = e.target.value;
        setFormData({ ...formData, [field]: newArray });
    };

    const handleServiceAndSpecializationChange = (e, field) => {
        const value = e.target.value.split(",").map(item => item.trim());
        setFormData({ ...formData, [field]: value });
    };

    const addField = (field, defaultValue) => {
        setFormData({ ...formData, [field]: [...formData[field], defaultValue] });
    };

    const removeField = (field, index) => {
        const newArray = [...formData[field]];
        newArray.splice(index, 1);
        setFormData({ ...formData, [field]: newArray });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_BASE_URL}/about`, formData);
            swal({
                title: "Success!", text: "Data added/updated successfully!", icon: "success", button: "OK",
            });
            setFormData({
                doctorId: "", description: "", education: [], workExperience: [], awards: [], services: [], specialization: [],
            });
            setShowEditForm(false);
            setShowAddForm(false);
            fetchDoctors();
        } catch (error) {
            console.error("Error adding/updating data:", error);
            swal({
                title: "Error!", text: 'Failed to add/update data: ' + (error.response?.data?.message || error.message), icon: "error", button: "OK",
            });
        }
    };

    const handleDelete = async (doctorId) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this doctor's profile!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                try {
                    await axios.delete(`${API_BASE_URL}/about/${doctorId}`);
                    swal("Poof! The profile has been deleted!", { icon: "success" });
                    fetchDoctors();
                } catch (error) {
                    console.error("Error deleting profile:", error);
                    swal("Oops!", 'Failed to delete profile: ' + (error.response?.data?.message || error.message), "error");
                }
            } else {
                swal("The profile is safe!");
            }
        });
    };

    const handleEdit = (doctorId) => {
        setEditDoctorId(doctorId);
        const doctorToEdit = doctors.find(doctor => doctor.doctorId === doctorId);
        if (doctorToEdit) {
            setFormData({
                doctorId: doctorToEdit.doctorId || "",
                description: doctorToEdit.description || "",
                education: doctorToEdit.education || [],
                workExperience: doctorToEdit.workExperience || [],
                awards: doctorToEdit.awards || [],
                services: doctorToEdit.services || [],
                specialization: doctorToEdit.specialization || [],
            });
            setShowEditForm(true);
            setShowAddForm(false);
        }
    };

    const handleAddDoctorClick = () => {
        setShowAddForm(true);
        setShowEditForm(false);
        setEditDoctorId(null);
        setFormData({
            doctorId: "", description: "", education: [], workExperience: [], awards: [], services: [], specialization: [],
        });
    };

    const renderDoctorList = () => (
        <div className="adddoctor-row" id="adddoctor-list-row">
            <div className="adddoctor-col-sm-12">
                <div className="adddoctor-card adddoctor-table-card">
                    <div className="adddoctor-card-body">
                        <div className="adddoctor-table-responsive">
                            <table className="adddoctor-datatable adddoctor-table adddoctor-table-hover adddoctor-table-center adddoctor-mb-0">
                                <thead>
                                    <tr>
                                        <th id="adddoctor-th-doctorId">Doctor ID</th>
                                        <th id="adddoctor-th-description">Description</th>
                                        <th id="adddoctor-th-education">Education</th>
                                        <th id="adddoctor-th-workExperience">Work Experience</th>
                                        <th id="adddoctor-th-awards">Awards</th>
                                        <th id="adddoctor-th-services">Services</th>
                                        <th id="adddoctor-th-specializations">Specializations</th>
                                        <th className="adddoctor-actions-column" id="adddoctor-th-action">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {doctors.map((doctor) => (
                                        <tr key={doctor.doctorId || doctor._id} id={`adddoctor-row-${doctor.doctorId || doctor._id}`}>
                                            <td data-label="Doctor ID:" className="adddoctor-td">{doctor.doctorId}</td>
                                            <td data-label="Description:" className="adddoctor-td adddoctor-description-cell">
                                                {doctor.description}
                                            </td>
                                            <td data-label="Education:" className="adddoctor-td">
                                                {doctor.education && doctor.education.map((edu, index) => (
                                                    <div key={`edu-${index}`} className="adddoctor-detail-item">
                                                        <strong>{edu.degree}</strong> from {edu.university} ({edu.year})
                                                    </div>
                                                ))}
                                            </td>
                                            <td data-label="Work Experience:" className="adddoctor-td">
                                                {doctor.workExperience && doctor.workExperience.map((work, index) => (
                                                    <div key={`work-${index}`} className="adddoctor-detail-item">
                                                        {work.workplace} ({work.startYear} - {work.endYear || 'Present'})
                                                    </div>
                                                ))}
                                            </td>
                                            <td data-label="Awards:" className="adddoctor-td">
                                                {doctor.awards && doctor.awards.map((award, index) => (
                                                    <div key={`award-${index}`} className="adddoctor-detail-item">
                                                        <strong>{award.name}</strong> ({award.month} {award.year}): {award.description}
                                                    </div>
                                                ))}
                                            </td>
                                            <td data-label="Services:" className="adddoctor-td adddoctor-services-cell">
                                                {doctor.services && doctor.services.join(', ')}
                                            </td>
                                            <td data-label="Specializations:" className="adddoctor-td adddoctor-specializations-cell">
                                                {doctor.specialization && doctor.specialization.join(', ')}
                                            </td>
                                            <td data-label="Actions:" className="adddoctor-td adddoctor-actions-cell">
                                                <div className="adddoctor-actions-group">
                                                    <button className="adddoctor-btn adddoctor-btn-edit" onClick={() => handleEdit(doctor.doctorId)} id={`adddoctor-edit-${doctor.doctorId}`}>
                                                        <i className="fe fe-pencil"></i> Edit
                                                    </button>
                                                    <button className="adddoctor-btn adddoctor-btn-delete" onClick={() => handleDelete(doctor.doctorId)} id={`adddoctor-delete-${doctor.doctorId}`}>
                                                        <i className="fe fe-trash"></i> Delete
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderDoctorForm = () => {
        // <<< NEW LOGIC: Filter doctors who do not have a profile yet >>>
        const existingProfileDoctorIds = new Set(doctors.map(p => p.doctorId));
        const availableDoctorsForProfile = allRegisteredDoctors.filter(
            doc => !existingProfileDoctorIds.has(doc.doctorId)
        );

        return (
            <div className="adddoctor-form-outer-container" id="adddoctor-profile-form-container">
                <h2 className="adddoctor-form-main-title" id="adddoctor-form-title-text">
                    {showEditForm ? 'Edit Doctor Profile' : 'Add New Doctor Profile'}
                </h2>
                <form onSubmit={handleSubmit} className="adddoctor-profile-management-form" id="adddoctor-doctorForm">
                    <div className="adddoctor-form-grid">
                        <div className="adddoctor-form-group adddoctor-grid-span-2" id="adddoctor-group-doctorId">
                            <label htmlFor="adddoctor-input-doctorId" className="adddoctor-form-label">Doctor *</label>
                            
                            {/* <<< MODIFIED PART: Conditional rendering for Doctor ID field >>> */}
                            {showAddForm ? (
                                // When ADDING a new profile, show a dropdown
                                <select
                                    id="adddoctor-input-doctorId"
                                    name="doctorId"
                                    value={formData.doctorId}
                                    onChange={handleChange}
                                    className="adddoctor-form-input"
                                    required
                                >
                                    <option value="" disabled>-- Select a Doctor to Add Profile For --</option>
                                    {availableDoctorsForProfile.length > 0 ? (
                                        availableDoctorsForProfile.map(doctor => (
                                            // Assumes doctor object has 'doctorId' and 'name'
                                            <option key={doctor.doctorId} value={doctor.doctorId}>
                                                {doctor.name} ({doctor.doctorId})
                                            </option>
                                        ))
                                    ) : (
                                        <option value="" disabled>No new doctors to add profiles for</option>
                                    )}
                                </select>
                            ) : (
                                // When EDITING, show a disabled text input
                                <input
                                    type="text"
                                    id="adddoctor-input-doctorId"
                                    name="doctorId"
                                    value={formData.doctorId}
                                    className="adddoctor-form-input"
                                    required
                                    disabled // It's always disabled in edit mode
                                />
                            )}
                        </div>

                        <div className="adddoctor-form-group adddoctor-grid-span-2" id="adddoctor-group-description">
                            <label htmlFor="adddoctor-input-description" className="adddoctor-form-label">Description</label>
                            <textarea
                                id="adddoctor-input-description"
                                name="description"
                                placeholder="Brief professional description (max 500 characters)"
                                value={formData.description}
                                onChange={handleChange}
                                className="adddoctor-form-textarea"
                                rows="4"
                            />
                        </div>
                    </div>

                    {['education', 'workExperience', 'awards'].map(section => (
                        <div className="adddoctor-form-section" key={section} id={`adddoctor-section-${section}`}>
                            <h3 className="adddoctor-section-title">{section.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</h3>
                            {formData[section].map((item, index) => (
                                <div key={`${section}-${index}`} className="adddoctor-repeatable-item">
                                    {section === 'education' && (
                                        <>
                                            <input type="text" placeholder="University Name" value={item?.university || ""} onChange={(e) => handleArrayChange(e, section, index, "university")} className="adddoctor-form-input" />
                                            <input type="text" placeholder="Degree Name" value={item?.degree || ""} onChange={(e) => handleArrayChange(e, section, index, "degree")} className="adddoctor-form-input" />
                                            <input type="text" placeholder="Year of Completion" value={item?.year || ""} onChange={(e) => handleArrayChange(e, section, index, "year")} className="adddoctor-form-input" />
                                        </>
                                    )}
                                    {section === 'workExperience' && (
                                        <>
                                            <input type="text" placeholder="Workplace Name" value={item?.workplace || ""} onChange={(e) => handleArrayChange(e, section, index, "workplace")} className="adddoctor-form-input" />
                                            <input type="text" placeholder="Start Year" value={item?.startYear || ""} onChange={(e) => handleArrayChange(e, section, index, "startYear")} className="adddoctor-form-input" />
                                            <input type="text" placeholder="End Year (or 'Present')" value={item?.endYear || ""} onChange={(e) => handleArrayChange(e, section, index, "endYear")} className="adddoctor-form-input" />
                                        </>
                                    )}
                                    {section === 'awards' && (
                                        <>
                                            <input type="text" placeholder="Award Name" value={item?.name || ""} onChange={(e) => handleArrayChange(e, section, index, "name")} className="adddoctor-form-input" />
                                            <input type="text" placeholder="Month (e.g., 'Jan')" value={item?.month || ""} onChange={(e) => handleArrayChange(e, section, index, "month")} className="adddoctor-form-input" />
                                            <input type="text" placeholder="Year" value={item?.year || ""} onChange={(e) => handleArrayChange(e, section, index, "year")} className="adddoctor-form-input" />
                                            <textarea placeholder="Brief description of the award" value={item?.description || ""} onChange={(e) => handleArrayChange(e, section, index, "description")} className="adddoctor-form-textarea adddoctor-grid-span-full" />
                                        </>
                                    )}
                                    <button type="button" onClick={() => removeField(section, index)} className="adddoctor-btn adddoctor-btn-remove-item" id={`adddoctor-remove-${section}-${index}`}>
                                        <i className="fe fe-minus-circle"></i> Remove
                                    </button>
                                </div>
                            ))}
                            <button
                                type="button"
                                onClick={() => addField(section, section === 'education' ? { university: "", degree: "", year: "" } : section === 'workExperience' ? { workplace: "", startYear: "", endYear: "" } : { month: "", year: "", name: "", description: "" })}
                                className="adddoctor-btn adddoctor-btn-add-item"
                                id={`adddoctor-add-${section}-btn`}
                            >
                                <i className="fe fe-plus-circle"></i> Add {section.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                            </button>
                        </div>
                    ))}

                    <div className="adddoctor-form-section adddoctor-grid-span-2" id="adddoctor-section-services">
                        <h3 className="adddoctor-section-title">Services Offered</h3>
                        <label htmlFor="adddoctor-input-services" className="adddoctor-form-label adddoctor-form-label-inline">
                            Enter services separated by commas (e.g., General Checkup, Vaccination, Minor Surgery)
                        </label>
                        <input
                            type="text"
                            id="adddoctor-input-services"
                            name="services"
                            placeholder="e.g., Cardiology Consultation, ECG, Echocardiogram"
                            value={formData.services.join(", ")}
                            onChange={(e) => handleServiceAndSpecializationChange(e, "services")}
                            className="adddoctor-form-input"
                        />
                    </div>

                    <div className="adddoctor-form-section adddoctor-grid-span-2" id="adddoctor-section-specialization">
                        <h3 className="adddoctor-section-title">Specializations</h3>
                        <label htmlFor="adddoctor-input-specialization" className="adddoctor-form-label adddoctor-form-label-inline">
                            Enter specializations separated by commas (e.g., Cardiology, Pediatrics, Neurology)
                        </label>
                        <input
                            type="text"
                            id="adddoctor-input-specialization"
                            name="specialization"
                            placeholder="e.g., Interventional Cardiology, Pediatric Oncology"
                            value={formData.specialization.join(", ")}
                            onChange={(e) => handleServiceAndSpecializationChange(e, "specialization")}
                            className="adddoctor-form-input"
                        />
                    </div>

                    <div className="adddoctor-form-actions adddoctor-grid-span-2" id="adddoctor-form-action-buttons">
                        <button type="submit" className="adddoctor-btn adddoctor-btn-primary adddoctor-btn-submit" id="adddoctor-submit-form-btn">
                            {showEditForm ? 'Update Profile' : 'Save Profile'}
                        </button>
                        <button type="button" className="adddoctor-btn adddoctor-btn-secondary" onClick={() => { setShowAddForm(false); setShowEditForm(false); setEditDoctorId(null); }} id="adddoctor-cancel-form-btn">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        )
    };

    if (loading && !doctors.length) {
        return (
            <div className="adddoctor-loading-container" id="adddoctor-initial-loader">
                <div className="adddoctor-spinner"></div>
                <p>Loading doctor profiles...</p>
            </div>
        );
    }

    if (error && !doctors.length) {
        return (
            <div className="adddoctor-error-container" id="adddoctor-initial-error">
                <p>Error loading data: {error.message}. Please try refreshing the page.</p>
            </div>
        );
    }

    return (
        <div className="adddoctor-main-wrapper" id="adddoctor-page-container">
            <AdminSidebar />
            <div className="adddoctor-page-wrapper" id="adddoctor-content-area">
                <div className="adddoctor-content adddoctor-container-fluid">
                    <div className="adddoctor-page-header" id="adddoctor-main-header-block">
                        <div className="adddoctor-row">
                            <div className="adddoctor-col-sm-7 adddoctor-col-auto">
                                <h1 className="adddoctor-page-title" id="adddoctor-main-title-text">Manage Doctor Profiles</h1>
                                <ul className="adddoctor-breadcrumb" id="adddoctor-breadcrumb-nav">
                                    <li className="adddoctor-breadcrumb-item"><NavLink to="/admin/dashboard">Dashboard</NavLink></li>
                                    <li className="adddoctor-breadcrumb-item adddoctor-active">Doctor Profiles</li>
                                </ul>
                            </div>
                            <div className="adddoctor-col-sm-5 adddoctor-col adddoctor-header-actions" id="adddoctor-header-action-buttons">
                                {!(showAddForm || showEditForm) && (
                                    <button className="adddoctor-btn adddoctor-btn-primary adddoctor-btn-add-new" onClick={handleAddDoctorClick} id="adddoctor-addNewDoctorBtn">
                                        <i className="fe fe-plus"></i> Add New Profile
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    {!(showEditForm || showAddForm) ? renderDoctorList() : null}
                    {(showEditForm || showAddForm) && renderDoctorForm()}
                </div>
            </div>
        </div>
    );
};

export default ManageDoctorProfiles;